<div
  *ngIf="shortCutFlowActive$ | async"
  data-testid="shortcut-flow"
  class="df-laptop-up flex--space-between flex--middle ps-medium nordic-blue-25-bg nordic-blue-100-border border rounded-large mr-small-b"
>
  <div class="flex flex--column">
    <h4 class="font-heading-5">
      {{ 'paxDetails.shortCutFlowNotification.title' | finLocalization }}
    </h4>
    <span class="font-body-1 ps-xxsmall-t">
      {{ 'paxDetails.shortCutFlowNotification.paragraph' | finLocalization }}
    </span>
  </div>
  <fcom-button
    data-testid="shortcut-flow-pay-button"
    class="pay-button"
    [mode]="ButtonMode.FILL"
    [text]="'paxDetails.shortCutFlowNotification.cta' | finLocalization"
    (clickBtn)="buttonClick.emit({ skipToCheckout: true })"
  ></fcom-button>
</div>
